import { QueryResult, useQuery } from '@apollo/client'
import {
  OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQuery,
  OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQueryVariables,
} from '../../../types'
import { ONE_OFF_PAYMENT_OBJECTIVE_PAYMENT_TARGET_CORRECTION_PAYMENT_TARGET_BONUSOF_YEAR_WITH_OBJECTIVES } from '../OneOffPaymentQueries'

export default (
  employeeId: number,
  meetingId: number,
  referenceYear: number,
  includeAllTargetBoni: boolean,
): QueryResult<
  OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQuery,
  OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQueryVariables
> => {
  return useQuery<
    OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQuery,
    OneOffPaymentObjectivePaymentTargetCorrectionPaymentTargetBonusOfYearAndObjectivesQueryVariables
  >(ONE_OFF_PAYMENT_OBJECTIVE_PAYMENT_TARGET_CORRECTION_PAYMENT_TARGET_BONUSOF_YEAR_WITH_OBJECTIVES, {
    variables: {
      employeeId: employeeId,
      meetingId: meetingId,
      year: referenceYear,
      includeAllTargetBoni,
    },
    fetchPolicy: 'cache-and-network',
  })
}
